import { create } from '@edicom/common/element/create';
import { focusFirst } from '@edicom/common/element/focusFirst';
import element from './_element';

export default function ecElementService() {
  return {
    create,
    focusFirst,
    element,
  };
}
